import { render } from "./TableDocuments.vue?vue&type=template&id=51617382&scoped=true"
import script from "./TableDocuments.vue?vue&type=script&lang=js"
export * from "./TableDocuments.vue?vue&type=script&lang=js"

import "./TableDocuments.vue?vue&type=style&index=0&id=51617382&lang=sass&scoped=true"

import exportComponent from "/home/ploi/orthomatrix.orthosol.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51617382"]])

export default __exports__